import {frontend} from 'pageflow-scrolled/frontend';

import {LegacyBlogPost} from './LegacyBlogPost';

frontend.contentElementTypes.register('legacyBlogPost', {
  component: LegacyBlogPost
});
